import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useAppStyles = makeStyles({
  message: {
    ...shorthands.padding("16px"),
    color: "#23415a",
  },
  messageCompact: {
    ...shorthands.padding("8px"),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    margin: "8px 8px 0",
  },
  messageError: {
    color: "#a4262c",
    backgroundColor: "#fde7e9",
  },
  loading: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  signupCard: {
    ...shorthands.padding("16px"),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    rowGap: "12px",
    color: "#23415a",
    textAlign: "center",
    height: "100%",
  },
  signupImage: {
    display: "block",
    maxWidth: "100%",
    height: "auto",
  },
  signupImageLink: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    textDecorationLine: "none",
  },
  signupTitle: {
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
  },
  signupDescription: {
    color: "#23415a",
  },
});
